import {
  CloseOutlined,
  DeleteOutlined,
  DownloadOutlined,
  FileAddOutlined,
  FolderOutlined
} from "@ant-design/icons"
import { Button, Flex, Popconfirm, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface BulkActionBarProps {
  count: number
  onMove?: () => void
  onAddToAlbum?: () => void
  onDownload: () => void
  onDelete: () => void
  onClear: () => void
  canDelete: boolean
}

export function BulkActionBar({
  count,
  onMove,
  onAddToAlbum,
  onDownload,
  onDelete,
  onClear,
  canDelete
}: BulkActionBarProps) {
  const { t } = useTranslation()

  if (!count) return null

  return (
    <Flex
      align="center"
      justify="space-between"
      className="rounded-md border border-border bg-primary/5 px-3 py-2"
    >
      <Flex align="center" gap="small">
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined />}
          onClick={onClear}
        />
        <Text strong>
          {t("files.bulk.selected", { count })}
        </Text>
      </Flex>
      <Flex gap="small">
        {onMove && (
          <Button icon={<FolderOutlined />} onClick={onMove}>
            {t("files.actions.move")}
          </Button>
        )}
        {onAddToAlbum && (
          <Button icon={<FileAddOutlined />} onClick={onAddToAlbum}>
            {t("files.actions.addToAlbum")}
          </Button>
        )}
        <Button icon={<DownloadOutlined />} onClick={onDownload}>
          {t("files.actions.download")}
        </Button>
        {canDelete && (
          <Popconfirm
            title={t("files.bulk.deleteConfirm", { count })}
            okButtonProps={{ danger: true }}
            onConfirm={onDelete}
          >
            <Button danger icon={<DeleteOutlined />}>
              {t("files.actions.delete")}
            </Button>
          </Popconfirm>
        )}
      </Flex>
    </Flex>
  )
}
